/* Sample Box landing page (sections/nn-sample-box-landing.liquid).
 *
 * 1. Add-to-cart: adds the Mixed Box AND the free soda in one /cart/add.js
 *    call, then sends the customer straight to checkout (or the cart, per the
 *    section setting). The form still works without JS — it posts the box
 *    alone to /cart/add and lands on the cart page.
 *
 *    The soda is added at its own price; the store's automatic
 *    "Free Protein Soda with Mixed Box" discount is what makes it $0.
 *
 * 2. Sticky bar: slides in once the buy card has scrolled out of view.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ?plan=subscribe|onetime|multi and ?flavour=Chocolate let ads and emails land on a
  // pre-selected option without changing the page default.
  function urlParam(name) {
    try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; }
  }

  // The quantity box (data-sbl-qtys), when the section renders one. Quantity is
  // then independent of the purchase option, so the box count comes from here
  // rather than from the selected plan card.
  function selectedTier(form) {
    return form.querySelector('[data-sbl-qty-radio]:checked');
  }

  function selectedPlan(form) {
    var r = form.querySelector('[data-sbl-plan-radio]:checked');
    return r ? r.value : 'onetime';
  }

  // The delivery frequency reads the same whether it renders as a drop-down or
  // as pills, so everything downstream can ignore which one the page chose.
  function freqControl(form) {
    return form.querySelector('[data-sbl-plan-select]') ||
           form.querySelector('[data-sbl-freqs]');
  }

  function freqNode(form) {
    var sel = form.querySelector('[data-sbl-plan-select]');
    if (sel) return sel.options[sel.selectedIndex] || null;
    return form.querySelector('[data-sbl-freq-radio]:checked');
  }

  function freqId(form) {
    var sel = form.querySelector('[data-sbl-plan-select]');
    if (sel) return sel.value || null;
    var r = form.querySelector('[data-sbl-freq-radio]:checked');
    return r ? r.value : null;
  }

  // Pills are radios, so they need disabling the way the select does: a one-time
  // order must never post a selling plan when JS is off.
  function freqDisabled(form, off) {
    var sel = form.querySelector('[data-sbl-plan-select]');
    if (sel) { sel.disabled = off; return; }
    var radios = form.querySelectorAll('[data-sbl-freq-radio]');
    for (var i = 0; i < radios.length; i++) radios[i].disabled = off;
  }

  function quantity(form) {
    var input = form.querySelector('[data-sbl-qty-input]');
    if (!input) return 1;
    var n = parseInt(input.value, 10);
    return n > 0 ? n : 1;
  }

  // Subscription swap: jar first, refills after. The map is jar variant ->
  // refill variant plus a price per frequency, printed by the section.
  function swapMap(form) {
    var el = form.querySelector('[data-sbl-swap-map]');
    if (!el) return null;
    if (el._sblParsed === undefined) {
      try { el._sblParsed = JSON.parse(el.textContent); } catch (e) { el._sblParsed = null; }
    }
    return el._sblParsed;
  }

  // The refill for the jar that is selected, or null when the shopper asked to
  // keep getting jars (and whenever the pair is missing or out of stock).
  function chosenSwap(form) {
    var map = swapMap(form);
    if (!map || !map.jars) return null;
    var side = form.querySelector('[data-sbl-swap-radio]:checked');
    if (!side || side.value !== 'swap') return null;
    var boxEl = form.querySelector('[data-sbl-box-id]');
    var entry = boxEl ? map.jars[boxEl.getAttribute('data-sbl-box-id')] : null;
    if (!entry || entry.available === false) return null;
    return { property: map.property, refill: entry.refill };
  }

  // The opt-out tick box, when the section renders one. It lives in the gift
  // block, which sits outside the form, so look it up from the section root.
  function giftToggle(form) {
    var root = form.closest ? form.closest('[data-nn-sbl]') : null;
    return (root || document).querySelector('[data-sbl-gift-toggle]');
  }

  // No tick box means every page that never asked for one keeps its gifts.
  function giftsWanted(form) {
    var t = giftToggle(form);
    return !t || t.checked;
  }

  // The box line, plus the gift lines for the selected purchase option. With
  // "subscribe" the box carries the chosen selling plan; Shopify's own
  // subscription app prices it from there.
  function readItems(form) {
    var items = [];
    var plan = selectedPlan(form);
    var boxEl = form.querySelector('[data-sbl-box-id]');
    var boxId = boxEl ? parseInt(boxEl.getAttribute('data-sbl-box-id'), 10) : 0;
    if (boxId) {
      var card = form.querySelector('[data-sbl-plan-card="' + plan + '"]');
      var tier = selectedTier(form);
      var qty = tier
        ? parseInt(tier.value, 10) || 1
        : (card ? parseInt(card.getAttribute('data-sbl-qty'), 10) || 1 : 1);
      var mult = quantity(form);
      // Per-box flavours, when the picker is on: one line per box, then identical
      // flavours folded together so the cart shows "x3" rather than three rows of
      // the same thing. Left alone every box is the page's own variant, which
      // folds back into the single line this always used to send.
      var flavIds = [];
      var flavSelects = form.querySelectorAll('[data-sbl-flav-select]');
      if (flavSelects.length) {
        for (var fs = 0; fs < flavSelects.length; fs++) {
          var row = flavSelects[fs].closest('[data-sbl-flav-row]');
          if (row && row.hidden) continue;           // beyond the chosen quantity
          var vid = parseInt(flavSelects[fs].value, 10);
          if (vid) flavIds.push(vid);
        }
      }
      if (!flavIds.length) { for (var q2 = 0; q2 < qty; q2++) flavIds.push(boxId); }

      var byVariant = [];
      for (var fi = 0; fi < flavIds.length; fi++) {
        var found = null;
        for (var bv = 0; bv < byVariant.length; bv++) {
          if (byVariant[bv].id === flavIds[fi]) { found = byVariant[bv]; break; }
        }
        if (found) found.quantity += mult;
        else byVariant.push({ id: flavIds[fi], quantity: mult });
      }
      for (var bi = 0; bi < byVariant.length; bi++) {
        var box = byVariant[bi];
        if (plan === 'subscribe') {
          var fid = freqId(form);
          if (fid) box.selling_plan = parseInt(fid, 10);
          var swap = chosenSwap(form);
          if (swap) {
            box.properties = box.properties || {};
            box.properties[swap.property] = String(swap.refill);
          }
        }
        items.push(box);
      }
    }
    var list = form.querySelector('[data-sbl-gifts="' + plan + '"]') || form;
    var nodes = list.querySelectorAll('[data-sbl-item]');
    // Opting out drops the gifts, but never the bundle's companion line: that
    // one is a paid part of the "alt" offer, not something being given away.
    var wantGifts = giftsWanted(form);
    // The property names that mark a line as "meant to be free", collected from
    // the gift lines themselves. dropUnfreeGifts works off this list, not off
    // every '_' property in the cart: the box can carry one of its own (the
    // refill swap) and is very much paid for.
    var giftProps = {};
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!wantGifts && !n.hasAttribute('data-sbl-companion-item')) continue;
      var id = parseInt(n.getAttribute('data-sbl-item-id'), 10);
      if (!id) continue;
      var item = { id: id, quantity: parseInt(n.getAttribute('data-sbl-item-qty'), 10) || 1 };
      var propName = n.getAttribute('data-sbl-item-prop-name');
      if (propName) {
        item.properties = {};
        item.properties[propName] = n.getAttribute('data-sbl-item-prop-value') || 'true';
        if (propName.charAt(0) === '_' && !n.hasAttribute('data-sbl-companion-item')) {
          giftProps[propName] = true;
        }
      }
      items.push(item);
    }
    items.giftProps = giftProps;
    return items;
  }

  // Purchase-option cards: highlight the chosen one, enable the frequency
  // select only for subscribe (so a non-JS post never sends a selling plan
  // with a one-time order), swap the button label, keep the sub price in step.
  function bindPlans(root, form) {
    var radios = form.querySelectorAll('[data-sbl-plan-radio]');
    var tierRadios = form.querySelectorAll('[data-sbl-qty-radio]');
    if (!radios.length && !tierRadios.length) return;
    var freq = freqControl(form);
    var priceEl = form.querySelector('[data-sbl-sub-price]');
    var buttons = root.querySelectorAll('[data-sbl-submit][data-sbl-label-onetime]');
    // Companion (bundle) flavour picker: drives the companion cart line, the alt card's
    // thumbnail and the second photo in the hero.
    var companionItem = form.querySelector('[data-sbl-companion-item]');
    var companionRadios = form.querySelectorAll('[data-sbl-companion-radio]');
    var heroCompanion = root.querySelector('[data-sbl-hero-companion]');
    var altThumb = root.querySelector('[data-sbl-alt-thumb]');
    var mediaCard = root.querySelector('.nn-sbl__media-card');
    var applyCompanion = function () {
      var r = form.querySelector('[data-sbl-companion-radio]:checked');
      if (!r) return;
      var pills = form.querySelectorAll('[data-sbl-companion]');
      for (var c = 0; c < pills.length; c++) pills[c].classList.toggle('is-selected', pills[c].contains(r));
      if (companionItem) companionItem.setAttribute('data-sbl-item-id', r.value);
      var img = r.getAttribute('data-sbl-companion-image');
      if (heroCompanion && img && heroCompanion.getAttribute('src') !== img) heroCompanion.setAttribute('src', img);
      var th = r.getAttribute('data-sbl-companion-thumb');
      if (altThumb && th) altThumb.setAttribute('src', th);
    };
    var apply = function () {
      var plan = selectedPlan(form);
      if (heroCompanion) heroCompanion.hidden = plan !== 'alt';
      if (mediaCard) mediaCard.classList.toggle('is-bundle', plan === 'alt' && !!heroCompanion);
      var cards = form.querySelectorAll('[data-sbl-plan-card]');
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.toggle('is-selected', cards[i].getAttribute('data-sbl-plan-card') === plan);
      }
      freqDisabled(form, plan !== 'subscribe');
      // The frequency row sits under the quantities and only means anything on
      // the subscription.
      var freqRow = form.querySelector('[data-sbl-freqrow]');
      if (freqRow) freqRow.hidden = plan !== 'subscribe';

      // The badge belongs to the default flavour, so it comes and goes with the
      // value rather than being part of the option it sits on.
      var flavBadges = form.querySelectorAll('[data-sbl-flav-badge]');
      for (var fb = 0; fb < flavBadges.length; fb++) {
        var fsel = flavBadges[fb].parentNode.querySelector('[data-sbl-flav-select]');
        flavBadges[fb].hidden = !fsel || fsel.value !== fsel.getAttribute('data-sbl-flav-default');
      }

      // "Boxes per delivery" on the subscription, "Quantity" on the one-time.
      var qtysLabel = form.querySelector('[data-sbl-qtys-label]');
      if (qtysLabel) {
        var ql = qtysLabel.getAttribute('data-sbl-qtylabel-' + plan);
        if (ql) qtysLabel.textContent = ql;
      }

      // One flavour picker per box being bought, no more.
      var flavRows = form.querySelectorAll('[data-sbl-flav-row]');
      if (flavRows.length) {
        var tierNow = selectedTier(form);
        var boxes = tierNow ? parseInt(tierNow.value, 10) || 1 : 1;
        for (var fr = 0; fr < flavRows.length; fr++) {
          flavRows[fr].hidden = parseInt(flavRows[fr].getAttribute('data-sbl-flav-row'), 10) > boxes;
        }
      }
      var current = form.querySelector('[data-sbl-plan-card="' + plan + '"]');
      var livePrice = current ? current.getAttribute('data-sbl-card-price') : null;
      if (plan === 'subscribe' && freq && priceEl) {
        var o = freqNode(form);
        if (o && o.getAttribute('data-price')) livePrice = o.getAttribute('data-price');
      }
      // With a quantity box the price follows plan AND quantity, and every option
      // shows its own price for the plan now selected.
      var tierOpts = form.querySelectorAll('[data-sbl-qty-option]');
      if (tierOpts.length) {
        var tierSel = selectedTier(form);
        for (var to = 0; to < tierOpts.length; to++) {
          var opt = tierOpts[to];
          var radio = opt.querySelector('[data-sbl-qty-radio]');
          opt.classList.toggle('is-selected', !!radio && radio.checked);
          var pEl = opt.querySelector('[data-sbl-tier-price]');
          var tPrice = opt.getAttribute('data-sbl-tier-price-' + plan);
          if (pEl && tPrice) pEl.textContent = tPrice;
          // Per-bar belongs to the quantity now, so it lives on the option and
          // follows the plan as well as the count. Only the figure is written:
          // the words after it are the same whichever plan is chosen.
          var amtOpt = opt.querySelector('[data-sbl-tier-amt]');
          var tAmt = opt.getAttribute('data-sbl-tier-amt-' + plan);
          if (amtOpt && tAmt) amtOpt.textContent = tAmt;
          // The strikethrough only means anything against the one-time price.
          var wasEl = opt.querySelector('[data-sbl-tier-was]');
          if (wasEl) {
            var wasVal = opt.getAttribute('data-sbl-tier-was-onetime');
            var showWas = plan !== 'subscribe' && !!wasVal;
            wasEl.textContent = wasVal || '';
            wasEl.hidden = !showWas;
          }
        }
        if (tierSel) {
          var selOpt = tierSel.closest('[data-sbl-qty-option]');
          var tp = selOpt && selOpt.getAttribute('data-sbl-tier-price-' + plan);
          if (tp) livePrice = tp;
          var per = selOpt && selOpt.getAttribute('data-sbl-tier-per-' + plan);
          if (per) {
            var perEls = root.querySelectorAll('[data-sbl-live-per]');
            for (var pe = 0; pe < perEls.length; pe++) perEls[pe].textContent = per;
          }
          // "1 box every 4 weeks — $34.95 $33.20": the order in words, against
          // what it costs. The struck price only appears where there is a real
          // saving to show, which is the subscription.
          var recap = form.querySelector('[data-sbl-recap]');
          if (recap) {
            var nameEl = selOpt && selOpt.querySelector('.nn-sbl__qtyopt-name');
            var qtyName = nameEl ? nameEl.textContent.trim() : '';
            var words = qtyName;
            if (plan === 'subscribe') {
              var fo = freqNode(form);
              var every = fo && (fo.getAttribute('data-every') || fo.textContent.trim());
              if (every) words += ' every ' + every.replace(/^every\s+/i, '');
            }
            var tEl = recap.querySelector('[data-sbl-recap-text]');
            if (tEl) tEl.textContent = words;
            var nowEl = recap.querySelector('[data-sbl-recap-now]');
            if (nowEl) nowEl.textContent = livePrice || '';
            var wasEl2 = recap.querySelector('[data-sbl-recap-was]');
            if (wasEl2) {
              var wasVal2 = plan === 'subscribe'
                ? selOpt.getAttribute('data-sbl-tier-price-onetime')
                : '';
              var showWas2 = !!wasVal2 && wasVal2 !== livePrice;
              wasEl2.textContent = wasVal2 || '';
              wasEl2.hidden = !showWas2;
            }
          }
        }
      }
      if (livePrice) {
        var lp = root.querySelectorAll('[data-sbl-live-price]');
        for (var p = 0; p < lp.length; p++) lp[p].textContent = livePrice;
      }
      var finalLabel = current ? current.getAttribute('data-sbl-final-label') : null;
      if (finalLabel) {
        var ll = root.querySelectorAll('[data-sbl-live-label]');
        for (var q = 0; q < ll.length; q++) ll[q].textContent = finalLabel;
      }
      // Headline package title, sub line and per-serve line follow the plan (each plan's text is pre-rendered; the price is a live-price element).
      var planTexts = root.querySelectorAll('[data-sbl-plan-text]');
      for (var t = 0; t < planTexts.length; t++) planTexts[t].hidden = planTexts[t].getAttribute('data-sbl-plan-text') !== plan;
      var vflags = root.querySelectorAll('[data-sbl-value-flag]');
      for (var vf = 0; vf < vflags.length; vf++) { var vt = vflags[vf].getAttribute('data-sbl-value-' + plan) || ''; vflags[vf].textContent = vt; vflags[vf].hidden = !vt; }
      var notes = root.querySelectorAll('[data-sbl-plan-note]');
      for (var n = 0; n < notes.length; n++) {
        var note = notes[n].getAttribute('data-sbl-note-' + plan) || '';
        notes[n].textContent = note;
        notes[n].hidden = !note;
      }
      // A plan whose label names the gift can print a "-nogift" alternative for
      // the opted-out state; plans that never mention it just keep their label.
      var noGift = !giftsWanted(form);
      for (var b = 0; b < buttons.length; b++) {
        var attr = 'data-sbl-label-' + plan;
        var label = (noGift && buttons[b].getAttribute(attr + '-nogift')) || buttons[b].getAttribute(attr);
        var main = buttons[b].querySelector('[data-sbl-cta-main]');
        var sub = buttons[b].querySelector('[data-sbl-cta-sub]');
        if (label && buttons[b].getAttribute('aria-busy') !== 'true') { if (main) main.textContent = label; else buttons[b].textContent = label; }
        buttons[b].setAttribute('data-sbl-label', label || (main ? main.textContent : buttons[b].textContent));
        if (sub) { var st = buttons[b].getAttribute('data-sbl-note-' + plan) || ''; sub.textContent = st; sub.hidden = !st; }
      }
      if (freq && priceEl) {
        var opt = freqNode(form);
        if (opt && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
      }
      // Pills carry their own selected state; the select does not need one.
      var pills = form.querySelectorAll('[data-sbl-freq]');
      for (var fp = 0; fp < pills.length; fp++) {
        var fr = pills[fp].querySelector('[data-sbl-freq-radio]');
        pills[fp].classList.toggle('is-selected', !!fr && fr.checked);
      }
    };
    for (var r = 0; r < radios.length; r++) radios[r].addEventListener('change', apply);
    if (freq) freq.addEventListener('change', apply);
    // Opting in or out only changes the CTA wording here; the cart lines are
    // read fresh on submit.
    var gToggle = giftToggle(form);
    if (gToggle) {
      gToggle.addEventListener('change', function () {
        var block = gToggle.closest('.nn-sbl__gift');
        if (block) block.classList.toggle('is-declined', !gToggle.checked);
        apply();
      });
    }
    for (var cr = 0; cr < companionRadios.length; cr++) companionRadios[cr].addEventListener('change', function () { applyCompanion(); apply(); });
    applyCompanion();
    // Clicking anywhere on a card picks it (the select inside stays usable).
    var cardsAll = form.querySelectorAll('[data-sbl-plan-card]');
    for (var c = 0; c < cardsAll.length; c++) {
      cardsAll[c].addEventListener('click', function (e) {
        if (e.target && e.target.tagName === 'SELECT') return;
        var radio = this.querySelector('[data-sbl-plan-radio]');
        if (radio && !radio.checked) { radio.checked = true; apply(); }
      });
    }
    // Australia can carry two bundle cards; ?bundle=alt|jars (or the section default) decides which shows.
    var altCard = form.querySelector('[data-sbl-plan-card="alt"]');
    var multiCard = form.querySelector('[data-sbl-plan-card="multi"]');
    if (altCard) {
      var plans = form.querySelector('[data-sbl-plans]');
      var altDefault = !!(plans && plans.getAttribute('data-sbl-alt-default') === 'true');
      var wantBundle = urlParam('bundle') || (altDefault ? 'alt' : 'jars');
      // No multi-jar card at all (au_show_bundle off) means the alt bundle is the only bundle: always show it.
      if (!multiCard || wantBundle === 'alt' || wantBundle === 'bars') {
        if (multiCard) multiCard.hidden = true;
        altCard.hidden = false;
        var mr = multiCard && multiCard.querySelector('[data-sbl-plan-radio]'), ar = altCard.querySelector('[data-sbl-plan-radio]');
        if (ar && ((mr && mr.checked) || (altDefault && !urlParam('plan')))) ar.checked = true;
      }
    }
    // The quantity box: clicking the option picks it, like the plan cards above.
    var qtyOpts = form.querySelectorAll('[data-sbl-qty-option]');
    for (var qo = 0; qo < qtyOpts.length; qo++) {
      qtyOpts[qo].addEventListener('click', function () {
        var radio = this.querySelector('[data-sbl-qty-radio]');
        if (radio && !radio.checked) { radio.checked = true; apply(); }
      });
    }
    for (var qr = 0; qr < tierRadios.length; qr++) {
      tierRadios[qr].addEventListener('change', apply);
    }
    var flavSelectsAll = form.querySelectorAll('[data-sbl-flav-select]');
    for (var fsa = 0; fsa < flavSelectsAll.length; fsa++) {
      flavSelectsAll[fsa].addEventListener('change', apply);
    }

    var wantPlan = urlParam('plan');
    if (wantPlan) {
      var wr = form.querySelector('[data-sbl-plan-radio][value="' + wantPlan + '"]');
      if (wr && !wr.disabled) wr.checked = true;
    }
    // ?qty=2 lets an ad land straight on a quantity.
    var wantQty = urlParam('qty');
    if (wantQty) {
      var qrr = form.querySelector('[data-sbl-qty-radio][value="' + wantQty + '"]');
      if (qrr) qrr.checked = true;
    }
    apply();
  }

  // In-page jumps: plan-card links that scroll to a section, and section
  // buttons that pick a plan and scroll back to the buy box.
  function bindJumps(root, form) {
    function smooth(el) {
      if (!el) return;
      try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(); }
    }
    var links = root.querySelectorAll('[data-sbl-scroll-to]');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        e.stopPropagation(); // inside a plan card: don't change the selection
        smooth(target);
      });
    }
    var pickers = root.querySelectorAll('[data-sbl-select-plan]');
    for (var k = 0; k < pickers.length; k++) {
      pickers[k].addEventListener('click', function () {
        var radio = form.querySelector('[data-sbl-plan-radio][value="' + this.getAttribute('data-sbl-select-plan') + '"]');
        if (radio && !radio.disabled) {
          var card = radio.closest('[data-sbl-plan-card]');
          if (card) card.hidden = false;
          if (!radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        // The card grows once the bundle is selected (flavour picker, hero image), so let layout settle first.
        var dest = root.querySelector('.nn-sbl__plans-label') || root.querySelector('[data-sbl-plans]') || root.querySelector('.nn-sbl__hero-buy');
        setTimeout(function () { smooth(dest); }, 150);
      });
    }
  }

  function setBusy(root, busy) {
    var buttons = root.querySelectorAll('[data-sbl-submit]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var main = b.querySelector('[data-sbl-cta-main]');
      var sub = b.querySelector('[data-sbl-cta-sub]');
      if (busy) {
        b.setAttribute('aria-busy', 'true');
        if (!b.hasAttribute('data-sbl-label')) b.setAttribute('data-sbl-label', main ? main.textContent : b.textContent);
        if (main) { main.textContent = b.getAttribute('data-sbl-busy-label') || 'Adding…'; if (sub) sub.hidden = true; }
        else b.textContent = b.getAttribute('data-sbl-busy-label') || 'Adding…';
      } else {
        b.removeAttribute('aria-busy');
        if (b.hasAttribute('data-sbl-label')) { if (main) { main.textContent = b.getAttribute('data-sbl-label'); if (sub) sub.hidden = !sub.textContent; } else b.textContent = b.getAttribute('data-sbl-label'); }
      }
    }
  }

  function showError(form, message) {
    var el = form.querySelector('[data-sbl-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  // Flavour (variant) picker: the chosen variant becomes the cart line, the hero
  // image swaps to that variant's photo, and the matching nutrition tab opens.
  // Everything in the subscribe card that moves: the two "what repeats" rows,
  // the serves line, the "you pay X today, then Y" sentence, the saving in the
  // perks and the price in the button. One place, so they can never disagree.
  function bindSubscribe(root, form) {
    var map = swapMap(form);
    var block = form.querySelector('[data-sbl-swap]');
    var servesEl = form.querySelector('[data-sbl-serves]');
    var summaryEl = form.querySelector('[data-sbl-summary]');
    var savingEls = form.querySelectorAll('[data-sbl-perk-saving]');
    var ctaPrice = root.querySelectorAll('[data-sbl-cta-price]');
    if (!block && !servesEl && !summaryEl && !savingEls.length && !ctaPrice.length) return;

    var swapPrice = block && block.querySelector('[data-sbl-swap-price]');
    var keepPrice = block && block.querySelector('[data-sbl-keep-price]');
    var swapRadio = block && block.querySelector('[data-sbl-swap-radio][value="swap"]');
    var keepRadio = block && block.querySelector('[data-sbl-swap-radio][value="keep"]');

    var fill = function (tpl, values) {
      var out = tpl || '';
      for (var k in values) out = out.split('[' + k + ']').join(values[k]);
      return out;
    };

    var apply = function () {
      var boxEl = form.querySelector('[data-sbl-box-id]');
      var entry = (map && map.jars && boxEl) ? map.jars[boxEl.getAttribute('data-sbl-box-id')] : null;
      var usable = !!entry && entry.available !== false;
      var planId = freqId(form);
      var node = freqNode(form);
      var every = node ? (node.getAttribute('data-every') || '') : '';

      if (block) {
        block.hidden = !usable;
        // A jar with no refill behind it must not leave the refill selected.
        if (!usable && keepRadio && swapRadio && swapRadio.checked) keepRadio.checked = true;
        if (usable && planId) {
          var sp = entry.plans && entry.plans[planId];
          var jp = entry.jarPlans && entry.jarPlans[planId];
          if (swapPrice && sp) swapPrice.textContent = sp.money;
          if (keepPrice && jp) keepPrice.textContent = jp.money;
        }
        var rows = block.querySelectorAll('[data-sbl-swap-row]');
        for (var i = 0; i < rows.length; i++) {
          var r = rows[i].querySelector('[data-sbl-swap-radio]');
          rows[i].classList.toggle('is-selected', !!r && r.checked);
        }
      }

      // Which price repeats: the refill when it is chosen and real, else the jar.
      var sending = (usable && swapRadio && swapRadio.checked) ? 'plans' : 'jarPlans';
      var ongoing = (entry && planId && entry[sending]) ? entry[sending][planId] : null;
      var todayNode = form.querySelector('[data-sbl-sub-price]');
      var today = todayNode ? todayNode.textContent : '';

      if (servesEl && map) servesEl.textContent = fill(map.servesNote, { serves: map.serves, every: every });
      if (summaryEl && map && ongoing) {
        summaryEl.textContent = fill(map.summary, { today: today, then: ongoing.money, every: every });
      }
      if (ongoing) {
        for (var sv = 0; sv < savingEls.length; sv++) {
          var tpl = savingEls[sv].getAttribute('data-sbl-perk-saving');
          var text = savingEls[sv].querySelector('span');
          if (text) text.textContent = fill(tpl, { saving: ongoing.save });
        }
      }

      // The button's price follows the selected plan, not the subscription only.
      if (ctaPrice.length) {
        var plan = selectedPlan(form);
        var card = form.querySelector('[data-sbl-plan-card="' + plan + '"]');
        var shown = plan === 'subscribe' ? today : (card ? card.getAttribute('data-sbl-card-price') : '');
        for (var cp = 0; cp < ctaPrice.length; cp++) ctaPrice[cp].textContent = shown || '';
      }
    };

    // One delegated listener: the flavour pills, the frequency, the rows and the
    // plan cards all live inside this form.
    form.addEventListener('change', apply);
    form.addEventListener('input', apply);
    apply();
  }

  // Quantity stepper. It writes the input the rest of the code reads, and fires
  // a change so the button price and the summary follow.
  function bindQty(root, form) {
    var widget = form.querySelector('[data-sbl-qty-widget]');
    if (!widget) return;
    var input = widget.querySelector('[data-sbl-qty-input]');
    if (!input) return;
    var clamp = function () {
      var n = parseInt(input.value, 10);
      if (!(n > 0)) n = 1;
      if (n > 99) n = 99;
      input.value = n;
      return n;
    };
    var steps = widget.querySelectorAll('[data-sbl-qty-step]');
    for (var i = 0; i < steps.length; i++) {
      steps[i].addEventListener('click', function (e) {
        e.preventDefault();
        input.value = clamp() + parseInt(this.getAttribute('data-sbl-qty-step'), 10);
        clamp();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    input.addEventListener('change', clamp);
    input.addEventListener('blur', clamp);
  }

  function bindVariants(root, form) {
    var radios = form.querySelectorAll('[data-sbl-variant-radio]');
    if (!radios.length) return;
    var idInput = form.querySelector('[data-sbl-box-id]');
    var hero = root.querySelector('[data-sbl-hero-img]');
    var stickyImg = root.querySelector('[data-sbl-sticky] img');
    function apply() {
      var r = form.querySelector('[data-sbl-variant-radio]:checked');
      if (!r) return;
      var cards = form.querySelectorAll('[data-sbl-variant]');
      for (var i = 0; i < cards.length; i++) cards[i].classList.toggle('is-selected', cards[i].contains(r));
      if (idInput) { idInput.value = r.value; idInput.setAttribute('data-sbl-box-id', r.value); }
      var title = r.getAttribute('data-sbl-variant-title') || '';
      var img = r.getAttribute('data-sbl-variant-image');
      if (hero && img && hero.getAttribute('src') !== img) {
        hero.setAttribute('src', img);
        hero.setAttribute('srcset', r.getAttribute('data-sbl-variant-srcset') || '');
      }
      // The sticky bar's thumbnail follows the flavour too (same file as the hero, already loaded).
      if (stickyImg && img && stickyImg.getAttribute('src') !== img) stickyImg.setAttribute('src', img);
      var panel = root.querySelector('[data-sbl-hero-panel]');
      var color = r.getAttribute('data-sbl-variant-color');
      if (panel && color) panel.style.setProperty('--sbl-hero-bg', color);
      if (color) root.style.setProperty('--sbl-hero-bg', color); // the header reads it too (card layout on phones)
      var names = root.querySelectorAll('[data-sbl-variant-name]');
      for (var n = 0; n < names.length; n++) names[n].textContent = title;
      var tabs = root.querySelectorAll('[data-sbl-nut-tab]');
      for (var t = 0; t < tabs.length; t++) {
        if (tabs[t].textContent.trim().toLowerCase() === title.toLowerCase()) {
          if (!tabs[t].classList.contains('is-active')) tabs[t].click();
          break;
        }
      }
    }
    for (var k = 0; k < radios.length; k++) radios[k].addEventListener('change', apply);
    var wantFlavour = urlParam('flavour') || urlParam('variant');
    if (wantFlavour) {
      for (var f = 0; f < radios.length; f++) {
        if ((radios[f].getAttribute('data-sbl-variant-title') || '').toLowerCase() === wantFlavour.toLowerCase() && !radios[f].disabled) { radios[f].checked = true; break; }
      }
    }
    apply();
  }

  // Gift lines are only ever meant to be free. If the store has no discount rule that
  // zeroes them (or it stopped applying), take them back out rather than charge for them.
  function dropUnfreeGifts(items, addedLines) {
    var propNames = (items && items.giftProps) || {};
    if (!Object.keys(propNames).length) return Promise.resolve();
    // /cart/add.js already answers with the added lines priced after automatic discounts
    // (final_line_price + discount allocations), so no second round trip is needed.
    var haveLines = addedLines && addedLines.length && typeof addedLines[0].final_line_price === 'number' && addedLines[0].key;
    var source = haveLines ? Promise.resolve({ items: addedLines }) : fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return source
      .then(function (cart) {
        var bad = [];
        (cart.items || []).forEach(function (line) {
          var props = line.properties || {};
          var isGift = false;
          for (var k in props) if (propNames[k]) isGift = true;
          if (isGift && line.final_line_price > 0) bad.push(line);
        });
        if (!bad.length) return;
        // One call for all of them (/cart/update.js takes a map of line key -> quantity).
        // Removing them one by one with /cart/change.js cost ~1s per line and 6.5s per checkout.
        var updates = {};
        for (var u = 0; u < bad.length; u++) updates[bad[u].key] = 0;
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function () { /* never block checkout on the safety net */ });
  }

  function bindForm(root, form) {
    var addUrl = form.getAttribute('data-sbl-add-url') || '/cart/add';
    var after = form.getAttribute('data-sbl-after') || 'checkout';
    var cartUrl = form.getAttribute('data-sbl-cart-url') || '/cart';
    var checkoutUrl = form.getAttribute('data-sbl-checkout-url') || '/checkout';

    form.addEventListener('submit', function (event) {
      if (!window.fetch || form.getAttribute('data-sbl-busy') === 'true') return;
      event.preventDefault();

      var items = readItems(form);
      if (!items.length) return;

      form.setAttribute('data-sbl-busy', 'true');
      setBusy(root, true);
      var err = form.querySelector('[data-sbl-error]');
      if (err) err.hidden = true;

      fetch(addUrl.replace(/\.js$/, '') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
        credentials: 'same-origin'
      })
        .then(function (r) {
          return r.json().then(function (body) {
            return { ok: r.ok, body: body };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) ||
              'Sorry, that could not be added. Please try again.';
            throw new Error(msg);
          }
          return dropUnfreeGifts(items, res.body && res.body.items);
        })
        .then(function () {
          window.location.href = after === 'cart' ? cartUrl : checkoutUrl;
        })
        .catch(function (e) {
          form.removeAttribute('data-sbl-busy');
          setBusy(root, false);
          showError(form, e && e.message ? e.message : 'Sorry, something went wrong. Please try again.');
        });
    });
  }

  function bindSticky(root) {
    var sticky = root.querySelector('[data-sbl-sticky]');
    var anchor = root.querySelector('[data-sbl-buy]');
    if (!sticky || !anchor) return;

    var shown = null;
    var show = function (visible) {
      if (visible === shown) return;
      shown = visible;
      sticky.hidden = !visible;
      var h = sticky.offsetHeight;
      document.body.style.paddingBottom = visible ? h + 'px' : '';
      document.documentElement.style.setProperty('--nn-sbl-sticky-h', h + 'px');
      document.documentElement.classList.toggle('nn-sbl-sticky-on', visible);
    };

    // Plain scroll check rather than an IntersectionObserver: on phones the
    // buy card starts below the first screen, and an observer only fires on
    // crossings, so a jump past it (anchor link, restored scroll position)
    // never showed the bar. Show it once the whole buy card is above the
    // viewport; hide while it is on screen or still below.
    var ticking = false;
    var check = function () {
      ticking = false;
      var rect = anchor.getBoundingClientRect();
      show(rect.bottom < 0);
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }

  // Nutrition panel: one tab per flavour.
  // "See the full label" opens the label image in a lightbox (native <dialog>); the link's
  // new-tab behaviour is the no-JS fallback and stays available inside the dialog.
  function bindLabelLightbox(root) {
    var dialog = root.querySelector('[data-sbl-label-dialog]');
    var links = root.querySelectorAll('[data-sbl-label-open]');
    if (!dialog || !links.length || typeof dialog.showModal !== 'function') return;
    var img = dialog.querySelector('[data-sbl-label-img]');
    var heading = dialog.querySelector('[data-sbl-label-heading]');
    function open(href, title) {
      img.setAttribute('src', href);
      img.setAttribute('alt', title ? title + ' nutrition label' : 'Nutrition label');
      if (heading) heading.textContent = title || '';
      dialog.showModal();
      document.documentElement.classList.add('nn-sbl-dialog-open');
    }
    function close() {
      if (dialog.open) dialog.close();
    }
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function (e) {
        e.preventDefault();
        open(this.getAttribute('href'), this.getAttribute('data-sbl-label-title') || '');
      });
    }
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    var closeBtn = dialog.querySelector('[data-sbl-label-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('nn-sbl-dialog-open'); });
  }

  function bindNutrition(root) {
    var wrap = root.querySelector('[data-sbl-nutrition]');
    if (!wrap) return;
    var tabs = wrap.querySelectorAll('[data-sbl-nut-tab]');
    var panels = wrap.querySelectorAll('[data-sbl-nut-panel]');
    var pick = function (id) {
      for (var t = 0; t < tabs.length; t++) {
        var on = tabs[t].getAttribute('data-sbl-nut-tab') === id;
        tabs[t].classList.toggle('is-active', on);
        tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      for (var p = 0; p < panels.length; p++) panels[p].hidden = panels[p].getAttribute('data-sbl-nut-panel') !== id;
    };
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function () { pick(this.getAttribute('data-sbl-nut-tab')); });
    }
  }

  ready(function () {
    // In-page jumps to the buy box (sticky bar / header in scroll mode): smooth, and clear of the sticky bar.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-sbl-jump], .nn-sbl a[href="#nn-sbl-buy"]');
      if (!a) return;
      var target = document.getElementById('nn-sbl-buy');
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 12;
      try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, top); }
    });
    var roots = document.querySelectorAll('[data-nn-sbl]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var form = root.querySelector('[data-sbl-form]');
      bindSticky(root);
      bindNutrition(root);
      bindLabelLightbox(root);
      if (form) { bindForm(root, form); bindPlans(root, form); bindVariants(root, form); bindSubscribe(root, form); bindQty(root, form); bindJumps(root, form); }
    }
  });
})();
